var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from 'cross-fetch';
import { encodeSerachParams } from './search-params';
export class TrelloClient {
    constructor({ baseUrl = '' } = {}) {
        this.baseUrl = baseUrl;
    }
    /**
     * @see https://developer.atlassian.com/cloud/trello/rest/#api-members-id-get
     */
    getMember({ id = 'me', organizations, organizationFields } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchParams = encodeSerachParams({
                organizations,
                organization_fields: organizationFields
            });
            const response = yield fetch(`${this.baseUrl}/1/members/${id}${searchParams ? `?${searchParams}` : ''}`, {
                credentials: 'include'
            });
            if (response.ok) {
                return yield response.json();
            }
            else {
                throw Error(yield response.text());
            }
        });
    }
}
//# sourceMappingURL=trello-client.js.map